export function betChipPreferenceKey(
  userId: number | string | undefined,
  roomCode: string,
  currency: string,
) {
  if (userId === undefined || userId === null || !roomCode) return '';
  return `sorteia:betChip:v1:${encodeURIComponent(String(userId))}:${encodeURIComponent(roomCode)}:${currency}`;
}

export function parseRememberedBetChip(value: string) {
  const amount = Number(value);
  return Number.isFinite(amount) && amount > 0 ? amount : null;
}

export function resolveInitialBetChip(chips: number[], remembered: number | null, maxSelectable: number) {
  const presets = [...new Set(chips)]
    .filter((chip) => Number.isFinite(chip) && chip > 0)
    .sort((left, right) => left - right);
  const available = presets.filter((chip) => chip <= maxSelectable);

  if (remembered !== null && available.includes(remembered)) return remembered;
  if (remembered !== null) {
    const lowerChips = available.filter((chip) => chip <= remembered);
    const safeLowerChip = lowerChips[lowerChips.length - 1];
    if (safeLowerChip !== undefined) return safeLowerChip;
  }
  return available[0] ?? presets[0] ?? 2;
}
